<script>
    import AdminFamilyPerson from './AdminFamilyPerson.svelte';

    export let family;
    export let txs;
</script>

<ul>
    {#each family.people as person (person.uid)}
        <li>
            <AdminFamilyPerson {person} {txs} {family} />
        </li>
    {/each}
</ul>